// extracted by mini-css-extract-plugin
export default {"navList":"NavList_navList__gWSx2","active":"NavList_active__9OJEY"};